var map = {
	"./CorpMessenger.png": 980,
	"./CorpMessenger_black.png": 1940,
	"./MONEYROAD-LOGO-2.png": 1941,
	"./MONEYROAD-LOGO.png": 1942,
	"./MenuFont.png": 1943,
	"./MoneyRoadLogo3.png": 1944,
	"./MoneyRoadLogoOld.png": 1945,
	"./MoneyRoadLogoOld2.png": 1946,
	"./StreamMind.png": 1947,
	"./StreamMind_horizontal.png": 1948,
	"./account.png": 981,
	"./banks.png": 982,
	"./clock_forward.png": 1949,
	"./edit.png": 1950,
	"./error.png": 1951,
	"./gearwheels.png": 1952,
	"./home.png": 1953,
	"./home_black.png": 1954,
	"./homepage/ask_for_modular_loan.png": 1955,
	"./homepage/proposer_modular_loan.png": 1956,
	"./homepage/request_a_document.png": 1957,
	"./homepage/request_to_pay.png": 1958,
	"./homepage/send_a_document.png": 1959,
	"./homepage/send_a_payment.png": 1960,
	"./icon-user.png": 1961,
	"./icons/MenuFont.png": 1962,
	"./icons/accept_doc.png": 1963,
	"./icons/accounts.png": 1964,
	"./icons/address_book2.png": 983,
	"./icons/address_book2_gray.png": 1965,
	"./icons/alarmclock.png": 1966,
	"./icons/attachment.png": 1967,
	"./icons/black_cross.png": 1968,
	"./icons/bookmarks.png": 984,
	"./icons/calendar.png": 1969,
	"./icons/canceled.png": 1970,
	"./icons/canceled_abort.png": 1971,
	"./icons/canceled_confirm.png": 1972,
	"./icons/clock_forward.png": 1973,
	"./icons/cloture_30.png": 1974,
	"./icons/cloture_31.png": 1975,
	"./icons/cloture_32.png": 1976,
	"./icons/cloture_33.png": 1977,
	"./icons/compass.png": 985,
	"./icons/compass_gray.png": 1978,
	"./icons/contacts.png": 1979,
	"./icons/credit_card.png": 1980,
	"./icons/credit_cards.png": 986,
	"./icons/credit_cards_gray.png": 1981,
	"./icons/credit_cards_white.png": 1982,
	"./icons/currency_euro.png": 1983,
	"./icons/dashboard.png": 1984,
	"./icons/document_empty.png": 1985,
	"./icons/door_exit.png": 987,
	"./icons/draft.png": 1986,
	"./icons/edit.png": 1987,
	"./icons/error.png": 1988,
	"./icons/expired.png": 1989,
	"./icons/eye.png": 1990,
	"./icons/eye_blind.png": 1991,
	"./icons/floppy_disk.png": 1992,
	"./icons/gauge.png": 988,
	"./icons/gauge_gray.png": 1993,
	"./icons/gearwheels.png": 138,
	"./icons/gearwheels_gray.png": 1994,
	"./icons/graphics_tablet_white.png": 1995,
	"./icons/hand_money.png": 1996,
	"./icons/hand_money_green.png": 1997,
	"./icons/hand_money_green_inst.png": 1998,
	"./icons/home.png": 1999,
	"./icons/hourglass.png": 2000,
	"./icons/icon_identite_black.png": 244,
	"./icons/icon_identite_white.png": 2001,
	"./icons/id_badge.png": 989,
	"./icons/id_badge_gray.png": 2002,
	"./icons/inbox.png": 2003,
	"./icons/inbox_into.png": 139,
	"./icons/inbox_into_gray.png": 2004,
	"./icons/inbox_out.png": 118,
	"./icons/inbox_out_gray.png": 2005,
	"./icons/information.png": 2006,
	"./icons/informations.png": 990,
	"./icons/inkpot.png": 991,
	"./icons/inkpot_gray.png": 2007,
	"./icons/invoice.png": 378,
	"./icons/loupe_black.png": 2008,
	"./icons/mail_forward.png": 2009,
	"./icons/mail_forward_alt.png": 2010,
	"./icons/mail_reply_all_white.png": 2011,
	"./icons/mail_reply_white.png": 2012,
	"./icons/mail_write.png": 992,
	"./icons/mail_write_gray.png": 2013,
	"./icons/mail_write_orange.png": 2014,
	"./icons/membersAccounts.png": 2015,
	"./icons/message.png": 2016,
	"./icons/messages.png": 2017,
	"./icons/money.png": 993,
	"./icons/money_inst.png": 2018,
	"./icons/negotiate_doc.png": 2019,
	"./icons/ok.png": 2020,
	"./icons/ok_edit.png": 2021,
	"./icons/old/clock_forward.png": 2022,
	"./icons/old/error.png": 2023,
	"./icons/old/graphics_tablet_white.png": 2024,
	"./icons/old/mail_forward.png": 2025,
	"./icons/old/mail_reply_all_white.png": 2026,
	"./icons/old/mail_reply_white.png": 2027,
	"./icons/old/mail_write_orange.png": 2028,
	"./icons/old/ok.png": 2029,
	"./icons/old/pencil_white.png": 2030,
	"./icons/old/server_out_white.png": 2031,
	"./icons/paperclip.png": 245,
	"./icons/paperclip_gray.png": 2032,
	"./icons/payment_made.png": 2033,
	"./icons/payment_made_inst.png": 2034,
	"./icons/pencil_white.png": 2035,
	"./icons/pilotage.png": 2036,
	"./icons/question.png": 2037,
	"./icons/receipt.png": 2038,
	"./icons/receipt_inst.png": 2039,
	"./icons/reject_doc.png": 2040,
	"./icons/rejected.png": 2041,
	"./icons/return_doc.png": 2042,
	"./icons/sales_quotation.png": 379,
	"./icons/send.png": 2043,
	"./icons/sentbox.png": 2044,
	"./icons/server_out_white.png": 2045,
	"./icons/settings.png": 2046,
	"./icons/signout.png": 994,
	"./icons/star_of_david.png": 2047,
	"./icons/timer_orange.png": 2048,
	"./icons/timer_orange_old_2.png": 2049,
	"./icons/trash.png": 995,
	"./icons/users5.png": 996,
	"./icons/users_relation.png": 997,
	"./icons/users_relation_gray.png": 2050,
	"./icons/warning.png": 998,
	"./icons/white_cross.png": 2051,
	"./image-profile.png": 380,
	"./inbox_into.png": 2052,
	"./inbox_out.png": 2053,
	"./list_style_bullets.png": 2054,
	"./logo/SEPA.png": 381,
	"./logo/SEPA_grey.png": 999,
	"./logo/bank/arkea.png": 2056,
	"./logo/bank/banque_pop.png": 2057,
	"./logo/bank/banque_postale.png": 2058,
	"./logo/bank/bnp.jpg": 2059,
	"./logo/bank/boursorama.jpg": 2060,
	"./logo/bank/ca.png": 2061,
	"./logo/bank/caisse_epargne.png": 2062,
	"./logo/bank/cic.png": 2063,
	"./logo/bank/credit_mutuel.png": 2064,
	"./logo/bank/hellobank.png": 2065,
	"./logo/bank/lcl.png": 2066,
	"./logo/bank/soge.png": 2067,
	"./logo/bank/square/arkea.png": 1000,
	"./logo/bank/square/banque_pop.jpg": 1001,
	"./logo/bank/square/banque_postale.png": 1002,
	"./logo/bank/square/bnp.png": 1003,
	"./logo/bank/square/boursorama.png": 1004,
	"./logo/bank/square/ca.png": 1005,
	"./logo/bank/square/caisse_epargne.png": 1006,
	"./logo/bank/square/cic.jpg": 1007,
	"./logo/bank/square/credit_mutuel.jpg": 1008,
	"./logo/bank/square/hellobank.png": 1009,
	"./logo/bank/square/lcl.png": 1010,
	"./logo/bank/square/other.png": 1011,
	"./logo/bank/square/soge.png": 1012,
	"./logo/cloudDoc.png": 1013,
	"./logo/exchangeDoc-grey.png": 1014,
	"./logo/exchangeDoc.png": 246,
	"./logo/invoicedirect_grey.png": 1015,
	"./logo/moneyroad_white_green.png": 1016,
	"./logo/mrlogo.png": 247,
	"./logo/old/SEPA.png": 2071,
	"./logo/old/exchangeDoc.png": 2072,
	"./logo/old/payment.png": 2073,
	"./logo/payments-grey.png": 1017,
	"./logo/payments.png": 248,
	"./logo/payslip.png": 1018,
	"./logoNew.png": 2074,
	"./logoStreamMind.png": 2075,
	"./mail_forward.png": 2076,
	"./mail_reply_all_white.png": 2077,
	"./mrlogo.png": 2078,
	"./ok.png": 2079,
	"./paperclip.png": 2080,
	"./pencil_black.png": 2081,
	"./plus.png": 2082,
	"./selectbox.png": 2083,
	"./server_out_white.png": 2084,
	"./server_out_white_2.png": 2085,
	"./streammindlogo.png": 2086,
	"./test.png": 2087
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2866;


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images \.(?:png|jpg)$
// module id = 2866
// module chunks = 2